// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import {
  Icon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from 'components/shared/Icon/Icon'
import { Tab } from './common/Tab/Tab'

import styles from './Tabs.module.scss'

const ChevronButton = ({
  icon,
  type,
  onClick,
  isDisabled,
  shouldRenderIcon = false,
}) => {
  const handleClick = React.useCallback(() => onClick(type), [type, onClick])

  return (
    <button
      className={styles.chevron}
      onClick={handleClick}
      disabled={isDisabled}
    >
      <span className={styles.content}>
        {shouldRenderIcon && (
          <Icon className={styles.icon} icon={icon} size={24} />
        )}
      </span>
    </button>
  )
}

export const Tabs = ({ children, className = undefined, isScrollable }) => {
  const [
    { shouldRenderLeftChevron, shouldRenderRightChevron },
    setScrollState,
  ] = React.useState({
    shouldRenderLeftChevron: false,
    shouldRenderRightChevron: true,
  })

  const ref = React.useRef()

  const handleScrollCapture = React.useCallback(() => {
    setScrollState({
      shouldRenderLeftChevron: R.gt(ref.current?.scrollLeft, 0),
      shouldRenderRightChevron: R.lt(
        ref.current?.scrollLeft + ref.current?.offsetWidth,
        ref.current?.scrollWidth,
      ),
    })
  }, [ref, setScrollState])

  const handleChevronClick = React.useCallback(
    type => {
      const mapSideToValue = {
        left: 0,
        right: ref?.current?.scrollWidth,
      }

      ref.current?.scroll({
        top: 0,
        left: mapSideToValue[type],
        behavior: 'smooth',
      })
    },
    [ref],
  )

  return (
    <div
      className={cx(styles.tabs, { [className]: Boolean(className) })}
      data-testid="tabs"
      onScrollCapture={handleScrollCapture}
    >
      {isScrollable && (
        <ChevronButton
          icon={ChevronLeftIcon}
          type="left"
          isDisabled={R.not(shouldRenderLeftChevron)}
          shouldRenderIcon={shouldRenderLeftChevron}
          {...(shouldRenderLeftChevron && {
            onClick: handleChevronClick,
          })}
        />
      )}
      <div className={styles.content} ref={ref}>
        {children}
      </div>
      {isScrollable && (
        <ChevronButton
          icon={ChevronRightIcon}
          type="right"
          isDisabled={R.not(shouldRenderRightChevron)}
          shouldRenderIcon={shouldRenderRightChevron}
          {...(shouldRenderRightChevron && {
            onClick: handleChevronClick,
          })}
        />
      )}
    </div>
  )
}

Tabs.Tab = Tab
